
  import ipxStaticRuntime$_5P2GsO7qgQOzv_45xVe1qeTE_45Qu4FrPM0O4JEqDgvetcM from '/home/runner/work/qx-solarheart/qx-solarheart/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipxStatic"} */
    provider: "ipxStatic",
    providers: {
        ['ipxStatic']: { setup: ipxStaticRuntime$_5P2GsO7qgQOzv_45xVe1qeTE_45Qu4FrPM0O4JEqDgvetcM, defaults: {} }
    }
  }
